import { Area } from "./AreaHierarchy"

export class Town extends Area {
    static entity = 'towns'

    // Reference to base entity name.
    static baseEntity = 'areas'

    // Call `super.fields()`` to merge fields.
    static fields() {
        return {
            ...super.fields()
        }
    }
}

// We also export a default.
export default Town;